export const LinenLaundryRouteDef = [ 
    {
        path: ':id/:resource',
        component: 'IndentIssueComponent',
        data: {
            selector: 'app-indent-issue'
        }
    }
]       